import moment from 'moment';
import Vue from 'vue';
import Sorting from '../../general/overview-grid/sorting';
import BaseGrid from '../../general/overview-grid/grid';
import RouteAssignmentModal from './routeassignment-modal';
import CancelOrderModal from './cancelorder-modal';

export default Vue.component('grid', {
    extends: BaseGrid,
    template:`
        <table class="table table-striped table-vcenter no-footer">
            <sorting v-bind="{ columns: columns, queryParameters: queryParameters }"></sorting>
            <tbody>
                <tr v-for="row in rows">
                    <td v-if="!row.isPendingProcess && row.editEnabled" class="font-w600">
                        <a :href="row.editUrl">{{ row.code }}</a>
                    </td>
                    <td v-else-if="!row.isPendingProcess && !row.editEnabled" class="font-w600">
                        <a :href="row.detailUrl">{{ row.code }}</a>
                    </td>
                    <td v-else-if="row.isPendingProcess && row.isBoUser" class="font-w600">
                        <a :href="row.editUrl">{{ row.code }}</a>
                    </td>
                    <td v-else class="font-w600">{{ row.code }}</td>
                    
                    <td v-if="row.originalOrderCode === null">
                        -
                    </td>
                    <td v-else-if="row.hasAccessToOriginalOrderColumn">
                        <a :href="row.originalOrderURL">{{ row.originalOrderCode }}</a>
                    </td>
                    <td v-else="row.originalOrderCode === null">{{row.originalOrderCode}}</td>

                    <td>{{ formatDateTime(row.creationDate) }}</td>
                    <td v-if="row.isBoUser">{{ formatDate(row.processDate) }}</td>
                    <td>{{ formatDateTime(row.plannedDate, resources.grid.notDefined) }}</td>
                    <td>{{ formatDateTime(row.pickedUpDate, resources.grid.notPickedUp) }}</td>
                    <td><span :class="stateLabelClass(row)">{{row.stateLabel}}</span></td>
                    
                    <td v-if="row.isBoUser">
                        <a :href="row.impersonateRequesterUrl">{{row.requesterName}}</a>
                    </td>
                    <td v-else>{{row.requesterName}}</td>
                    
                    <td v-if="row.isBoUser && row.transporterServicePointId !== null">
                        <a :href="row.impersonateTransporterUrl">{{row.transporterName}}</a>
                    </td>
                    <td v-else>{{row.transporterName}}</td>

                    <td v-if="row.isBoUser && row.receiverServicePointId !== null">
                        <a :href="row.impersonateReceiverUrl">{{row.receiverName}}</a>
                    </td>
                    <td v-else>{{row.receiverName}}</td>
                    <td>
                        <div class="btn-group btn-group-sm">
                            <button v-if="row.showAssignRouteAction" class="btn btn-dual js-tooltip" :title="resources.grid.assignRouteTitle" v-on:click="routeAssignment(row)">
                                <i class="fa fa-sm fa-fw fa-road"></i>
                            </button>
                            <a v-if="row.showEditAction" :href="row.editUrl" :title="resources.grid.editTitle" class="btn btn-dual js-tooltip">
                                <i class="fa-fw si si-pencil"></i>
                            </a>
                            <a v-if="row.showDetailAction" :href="row.detailUrl" :title="resources.grid.detailTitle" class="btn btn-dual js-tooltip">
                                <i class="fa-fw si si-eye"></i>
                            </a>
                            <button v-if="row.showCancelAction" class="btn btn-danger js-tooltip" :title="resources.grid.cancelTitle" v-on:click="cancelOrder(row)">
                                <i class="fa fa-sm fa-fw fa-times"></i>
                            </button>
                            <button v-if="row.showSplittedInfo" class="btn btn-secondary js-popover" :data-content="resources.grid.splittedInfoContent">
                                <i class="fa-fw si si-info"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    `,
    components:{
        'sorting': Sorting
    },
    methods:{
        stateLabelClass(row){
            if(row.isBilled)
                return 'badge badge-pill badge-success';
            if(row.isCancelled)
                return 'badge badge-pill badge-danger';
            return 'badge badge-pill badge-light';
        },
        formatDate(value){
            return value != null && value != undefined ? moment(value, moment.ISO_8601).format('L') : '';
        },
        formatDateTime(value, defaultValue){
            return value != null && value != undefined ? moment(value, moment.ISO_8601).format('DD-MM-YYYY H:mm') : defaultValue;
        },
        routeAssignment(row){
            this.axe.get('/routeassignmentmodal', { 
                params: { id: row.orderId }
            }).then((response) => { 
                this.showRouteAssignmentModal(row.orderId, response.data);
            }).catch((thrown) => {
                //todo : display notification message with message from resources
                console.log('app error', thrown.message);
            }).then(() => {
            
            });
        },
        showRouteAssignmentModal(orderId, modalData){
            this.$modal.show(RouteAssignmentModal, { 
                orderId: orderId,
                name: 'routeassignment',
                requester: modalData.requester,
                transporter: modalData.transporter,
                receiver: modalData.receiver,
                resources: modalData.resources,
                axe: this.axe
            }, {
                adaptive: true,
                height: 'auto',
                maxWidth: 450
            });
        },
        cancelOrder(row){
            this.axe.get('/cancelordermodal', { 
                params: { id: row.orderId }
            }).then((response) => { 
                this.showCancelOrderModal(response.data);
            }).catch((thrown) => {
                //todo : display notification message with message from resources
                console.log('app error', thrown.message);
            }).then(() => {
            
            });
        },
        showCancelOrderModal(modalData){
            this.$modal.show(CancelOrderModal, { 
                name: 'cancelorder',
                message: modalData.message,
                orderId: modalData.orderId,
                orderCode: modalData.orderCode,
                cancelAllowed: modalData.cancelAllowed,
                cutoffTimeReached: modalData.cutoffTimeReached,                
                resources: modalData.resources,
                axe: this.axe
            }, {
                adaptive: true,
                height: 'auto',
                maxWidth: 300
            });
        }
    }
});